/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_SubtitleInputs */



/**
* | output |
* | --- |
* | "Ready-made agents for everyday work. Pick one, adjust it to your team, and create it." |
*
* @param {Agent_Templates_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_subtitle = /** @type {((inputs?: Agent_Templates_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fertige Agenten für die tägliche Arbeit. Wählen Sie einen aus, passen Sie ihn an Ihr Team an und legen Sie ihn an.")
	return /** @type {LocalizedString} */ ("Ready-made agents for everyday work. Pick one, adjust it to your team, and create it.")
});